
            const data = {"name":"about/fb","data":{"width":"11","height":"22","viewBox":"0 0 11 22","data":"<path pid=\"0\" d=\"M6.812 21.882V11.055h3.03l.402-3.81H6.812l.005-1.908c0-.993.094-1.526 1.511-1.526h1.895V0H7.192C3.55 0 2.27 1.848 2.27 4.957v2.288H0v3.811h2.27v10.673a13.885 13.885 0 004.542.153z\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                